(() => {
  if (window.banditosTabletMenu) return;
  window.banditosTabletMenu = true;
  const range = window.matchMedia('(min-width: 768px) and (max-width: 1280px)');
  let panel, trigger;
  function close(focus = false) {
    if (!panel) return;
    panel.hidden = true;
    trigger?.setAttribute('aria-expanded', 'false');
    if (focus) trigger?.focus();
  }
  function position() {
    if (!panel || panel.hidden) return;
    const header = trigger.closest('.header-mobile');
    const bottom = Math.max(0, header.getBoundingClientRect().bottom);
    panel.style.top = `${bottom}px`;
    panel.style.maxHeight = `calc(100dvh - ${bottom + 16}px)`;
  }
  function build() {
    const items = [...document.querySelectorAll('.header__inline-menu .menu-lv-1:not(.banditos-mobile-menu-only)')];
    if (!items.length) return false;
    panel = document.createElement('nav');
    panel.id = 'banditos-tablet-menu';
    panel.className = 'banditos-tablet-menu';
    panel.setAttribute('aria-label', 'Main menu');
    panel.hidden = true;
    const row = document.createElement('div');
    row.className = 'btm-row';
    const content = document.createElement('div');
    content.className = 'btm-content';
    items.forEach((item, index) => {
      const source = item.querySelector(':scope > a');
      if (!source) return;
      const cards = [...item.querySelectorAll('[class*="__card-link"]')];
      const control = document.createElement(cards.length ? 'button' : 'a');
      control.className = 'btm-category';
      control.textContent = source.textContent.trim();
      if (!cards.length) control.href = source.href;
      else {
        control.type = 'button';
        control.setAttribute('aria-expanded', 'false');
        control.setAttribute('aria-controls', `btm-cards-${index}`);
        const group = document.createElement('div');
        group.id = `btm-cards-${index}`;
        group.className = 'btm-group';
        group.hidden = true;
        const overview = document.createElement('a');
        overview.className = 'btm-overview';
        overview.href = source.href;
        overview.textContent = `Explore ${source.textContent.trim()} →`;
        const grid = document.createElement('div');
        grid.className = 'btm-grid';
        cards.forEach(card => {
          const copy = card.cloneNode(true);
          copy.removeAttribute('id');
          copy.querySelectorAll('[id]').forEach(el => el.removeAttribute('id'));
          grid.append(copy);
        });
        group.append(overview, grid);
        content.append(group);
        control.addEventListener('click', () => {
          const opening = group.hidden;
          content.querySelectorAll('.btm-group').forEach(el => el.hidden = true);
          row.querySelectorAll('button').forEach(el => el.setAttribute('aria-expanded', 'false'));
          group.hidden = !opening;
          control.setAttribute('aria-expanded', String(opening));
        });
      }
      row.append(control);
    });
    const dismiss = document.createElement('button');
    dismiss.type = 'button';
    dismiss.className = 'btm-close';
    dismiss.textContent = '×';
    dismiss.setAttribute('aria-label', 'Close menu');
    dismiss.addEventListener('click', () => close(true));
    panel.append(row, dismiss, content);
    document.body.append(panel);
    return true;
  }
  document.addEventListener('click', event => {
    const button = event.target.closest('.header-mobile [data-mobile-menu]');
    if (button && range.matches) {
      if (!panel && !build()) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      trigger = button;
      trigger.setAttribute('aria-controls', panel.id);
      panel.hidden = !panel.hidden;
      trigger.setAttribute('aria-expanded', String(!panel.hidden));
      position();
    } else if (panel && !panel.hidden && !panel.contains(event.target)) close();
  }, true);
  document.addEventListener('keydown', event => { if (event.key === 'Escape') close(true); });
  window.addEventListener('scroll', position, { passive: true });
  window.addEventListener('resize', () => { if (!range.matches) close(); else position(); });
})();
